/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  ContainerCenter,
  ContainerCenterInside,
  MainContainer,
  TopDiv,
  Header,
  InputDiv,
  FlowButton,
} from "./styles";
import Menu from "../../components/general/Menu";
import TopBar from "../../components/general/TopBar";
import Search from "../../assets/icons/Search";
import Input from "../../components/general/Input";
import Button from "../../components/general/Button";

import ActiveIterable from "./Iterable";
import Flash from "../../assets/icons/Flash";

import { useSelector, useDispatch } from "react-redux";
import { openModal } from "../../state/zaivuPersist/slice";
import { useVerifyToken } from "../../hooks/useVerifyToken";
import { toastAlert } from "../../components/Toastify/index";
import { trackPromise } from "react-promise-tracker";
import { fetchActivedFlows } from "../../state/activedFlows/reducers";
import { useHistory } from "react-router-dom";
import { FilterOptions } from "../../components/FilterOptions";
import Pagination from "../../components/general/Pagination/index";
import ReactLoading from "react-loading";
import { RefreshButton } from "../../components/general/RefreshButton";
import { ProtectedComponent } from "../../components/general/Protected";
import { debounce } from "lodash";

const ActivedFlowsPage = ({ location }) => {
  //Poppers
  const [filtersOpen, setFiltersOpen] = useState(false);

  const params = new URLSearchParams(location.search);
  const history = useHistory();
  //url Params
  const [titleSearch, setTitleSearch] = useState(
    params.get("title") ? params.get("title") : "",
  ); //filtrar titulo do fluxo

  const [clientSearch, setClientSearch] = useState(
    params.get("clientSearch") ? params.get("clientSearch") : "",
  ); //filtrar titulo do fluxo

  const [typeFilter, setTypeFilter] = useState({
    title: params.get("title") ? params.get("title") : "",
    client: params.get("client") ? params.get("client") : "",
    alpha: params.get("alpha") ? params.get("alpha") === "true" : false,
    creation: params.get("creation")
      ? params.get("creation") === "true"
      : false,

    page: params.get("page") ? parseInt(params.get("page")) : 1,
  });


  const dispatch = useDispatch();

  const pagination = useSelector((state) => state.activedFlows.pagination);
  const aFlows = pagination.flows;
  const pagesFlow = pagination.pages;
  const status = pagination.status;

  const user = useSelector((state) => state.auth.user);
  const updateFilters = ({
    alpha = false,
    creation = false,
    page = 1,
    client = "",
    title = "",
  }) => {
    setTypeFilter({ alpha, creation, page, client, title });
    setUrlParams({ alpha, creation, page, client, title });
  };

  const setUrlParams = ({
    alpha = typeFilter.alpha,
    creation = typeFilter.creation,
    page = 1,
    title = "",
    client = "",
  }) => {
    history.push({
      search:
        "?" +
        new URLSearchParams({
          title,
          client,
          alpha,
          creation,
          page,
        }).toString(),
    });
  };

  async function fetchingActivedFlows(newPage = 1) {
    trackPromise(
      dispatch(
        fetchActivedFlows({
          queries: {
            filters: typeFilter,
          },
          page: newPage,
        }),
      ).then((res) => {
        if (res.error) {
          toastAlert({
            msg: `Ocorreu um erro ao carregar os projetos: '${res.payload.error}'`,
            isError: true,
          });
        }
      }),
      "fetchActivedFlows",
    );

    // dispatch(updatePromiseStatus(false))
  }

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      fetchingActivedFlows(typeFilter.page);
    }

    return () => (isMounted = false);
  }, [typeFilter]);


  const handleRefresh = debounce(() => {
    fetchingActivedFlows(typeFilter.page);
  }, 400);

  useVerifyToken();

  return (
    <TopDiv>
      <Menu />
      <MainContainer>
        <TopBar text={"Fluxos Ativos > Em Andamento"} />
        <ContainerCenter>
          <ContainerCenterInside>
            <Header>
              <InputDiv>
                <Input
                  value={titleSearch}
                  setValue={setTitleSearch}
                  Icon={() => <Search />}
                  placeholder="Pesquisar por título..."
                  buttonConfirmText="Pesquisar"
                  buttonConfirm={true}
                  onClickButton={() => {
                    updateFilters({ ...typeFilter, title: titleSearch });
                  }}
                />
              </InputDiv>

              <FlowButton>
                <RefreshButton
                  style={{ marginRight: "0.7rem" }}
                  onConfirm={handleRefresh}
                  size={28}
                />

                <ProtectedComponent
                  allowed={["admin", "gerente"]}
                  rank={user?.rank}
                >
                  <Button
                    style={{ width: "10rem" }}
                    Icon={() => <Flash />}
                    onClick={() => {
                      dispatch(openModal());
                    }}
                    content="Iniciar Fluxo"
                  />
                </ProtectedComponent>
              </FlowButton>

              <FilterOptions
                open={filtersOpen}
                setOpen={setFiltersOpen}
                type={typeFilter}
                setType={updateFilters}
                titleSearch={titleSearch}
                clientSearch={clientSearch}
                setClientSearch={setClientSearch}
                setUrlParams={setUrlParams}
              />
            </Header>
            {status === "succeeded" ? (
              <>
                {status === "succeeded" && aFlows.length > 0
                  ? aFlows.map((item, index) => (
                      <ActiveIterable
                        onClick={() =>
                          history.push({
                            pathname: "/workflow/",
                            state: "active",
                            search:
                              "?" +
                              new URLSearchParams({
                                flowId: item._id,
                              }).toString(),
                          })
                        }
                        key={index + Math.random()}
                        title={item.title}
                        startDate={item.createdAt}
                        estimatedAt={item.flowStatus?.estimatedAt}
                        criticalDate={item.flowStatus?.criticalDate}
                        jobs={item.flowStatus.activeJobs}
                        flowProgress={item.flowStatus.progress}
                        flowId={item._id}
                        client={item.client}
                        description={item.description}
                        relatedUsers={item.relatedUsers}
                      />
                    ))
                  : "Não há fluxos ativos no momento, clique em Iniciar fluxo para adicionar."}
              </>
            ) : (
              <ReactLoading type="bars" color="#118052" />
            )}
          </ContainerCenterInside>
        </ContainerCenter>
      </MainContainer>

      <Pagination
        style={{
          position: "absolute",
          bottom: "1.5rem",
          left: "50%",
        }}
        actualPage={typeFilter.page}
        onPageChange={(activePage) => {
          updateFilters({
            ...typeFilter,
            page: activePage,
          });
        }}
        numberOfPages={pagesFlow}
      />
    </TopDiv>
  );
};

export default ActivedFlowsPage;
